<template>
  <l-tela titulo="Salões" id="lateral">
    <l-consulta
      :colunas="colunas"
      :registros="registros"
      :totalPaginas="paginas"
      @cliqueLinha="abrirAlteracaoProduto"
      @buscarPagina="buscar"
    />

    <v-tooltip left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          fab
          large
          fixed
          bottom
          right
          v-bind="attrs"
          v-on="on"
          @click="abrirCadastro"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>
      <span>Adicionar novo produto</span>
    </v-tooltip>
  </l-tela>
</template>

<script>
import produtoService from '@/services/produto.service'
import LoadingMixin from '@/components/Mixins/Loading'
import NotificacaoMixin from '@/components/Mixins/Notificacao'

export default {
  mixins: [LoadingMixin, NotificacaoMixin],
  data() {
    return {
      colunas: [
        {
          text: 'Nome do espaço',
          align: 'start',
          sortable: false,
          value: 'nome',
          width: 500,
        },
        { text: 'Preço', value: 'preco', mascaraDinheiro: true },
      ],
      registros: [],
      paginas: 0,
    }
  },
  mounted() {
    this.buscar()
  },
  methods: {
    abrirCadastro() {
      this.$router.push({ name: 'rota-produtos-cadastrar' })
    },
    abrirAlteracaoProduto(registro) {
      const { _id } = registro
      if (_id) {
        this.$router.push({
          name: 'rota-produtos-alterar',
          params: { produtoId: _id },
        })
      }
    },
    async buscar(pagina = 1) {
      this.mostrarLoading()
      try {
        const produtos = await produtoService.buscaTodos(pagina)
        this.registros = produtos.lista
        this.paginas = produtos.pages
      } catch (error) {
        this.mostraNotificacao(error)
      } finally {
        this.fecharLoading()
      }
    },
  },
}
</script>
